import { FC, useCallback, useState } from 'react';
import styled from 'styled-components';
import {
  DirectoryHeader,
  InfoIconUrl,
  Main,
  Padding,
  Stack,
  useMutateToken,
  useTokensQuery,
} from '@atlas-frontend/sdk';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { Helmet } from 'react-helmet-async';
import translations from './TokenDirectory.translations.json';
import { TokenTable } from './TokenTable';
import { AddTokenModal } from './AddTokenModal';

const { addTranslations, useTranslation } = i18nNsFactory('tokens-directory');
addTranslations(translations);

export const TokenDirectory: FC = () => {
  const { t } = useTranslation();
  const { data = [], refetch, isLoading: isLoadingTokens } = useTokensQuery();
  const [isAddTokenModalOpen, setIsAddTokenModalOpen] = useState(false);

  const { mutateAsync, isPending: isDeletingToken } = useMutateToken();
  const handleDeleteToken = useCallback(
    async (id: number) => {
      await mutateAsync({ id });
      refetch();
    },
    [mutateAsync, refetch],
  );

  const isLoading = isLoadingTokens || isDeletingToken;

  return (
    <Main>
      <Main.Col>
        <Main.Header>
          <Helmet>
            <title>{t('tokens.title')}</title>
          </Helmet>
        </Main.Header>
        <Main.Content padding={false} id="tokens-content">
          <ContentWrapper>
            <DirectoryHeader
              title={t('tokens.title')}
              infoIconUrl={InfoIconUrl.TOKEN_DIRECTORY}
              onSearch={undefined}
            />
            <Padding horizontal bottom>
              <TokenTable
                data={data}
                isLoading={isLoading}
                onAddToken={() => setIsAddTokenModalOpen(true)}
                onDeleteToken={handleDeleteToken}
              />
            </Padding>
            {isAddTokenModalOpen && (
              <AddTokenModal
                onClose={() => setIsAddTokenModalOpen(false)}
                onSuccess={() => refetch()}
              />
            )}
          </ContentWrapper>
        </Main.Content>
      </Main.Col>
    </Main>
  );
};

const ContentWrapper = styled(Stack)`
  width: 100%;
  max-width: 120em;
  height: 100%;
  margin-right: auto;
  margin-left: auto;
`;
